import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Domain, Modules, Usecases } from '../core'

import NormalCardInput from '../components/screens/NormalCardInput'

type CreditCardToRegister = Domain.CreditCardToRegister.Entity | null

export default function NormalCardInputContainer() {
  const userStatus = useSelector((state: Modules.AppState) => state.userStatus)
  const dispatch = useDispatch<any>()
  const actions = React.useMemo(
    () => ({
      fetchUserStatus() {
        const reloder = () => {
          dispatch(Usecases.UserStatus.fetchUserStatus(reloder))
        }
        dispatch(Usecases.UserStatus.fetchUserStatus(reloder))
      },
      registerCard(card: CreditCardToRegister, navigate: () => void) {
        dispatch(Usecases.Card.registerCard(card, navigate))
      },
      updateCard(card: CreditCardToRegister, navigate: () => void) {
        dispatch(Usecases.Card.updateCard(card, navigate))
      },
      clearScreenEmbeddedErrorAlert() {
        dispatch(Modules.ErrorModule.clearError())
      },
    }),
    [dispatch]
  )

  return <NormalCardInput userStatus={userStatus} actions={actions} />
}
